import { AsyncSelectInputSingle } from '@frontend/basic-forms';

import { ApiQueryParams } from '@frontend/api-utils';
import { TransactionQueryParams } from '@frontend/transaction/types';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';
import useTransactionSelect from './transaction-select.controller';

const ID = 'transaction-select';
export interface TransactionSelectProps {
    id?: string;
    required?: boolean;
    submitted: boolean;
    onChange: (newValue?: string) => void;
    value?: string | null;
    className?: string;
    disabled?: boolean;
    label?: React.ReactNode;
    useConditionedStyling?: boolean;
    isClearable?: boolean;

    dispatch: ThunkDispatch<any, any, Action>;
    queryParams?: ApiQueryParams<TransactionQueryParams>;
}

export const TransactionSelect = (props: TransactionSelectProps) => {
    const viewProps = useTransactionSelect(props);

    return (
        <AsyncSelectInputSingle
            id={props.id || ID}
            label={props.label || 'Transaction'}
            className={props.className}
            submitted={props.submitted}
            required={props.required}
            options={viewProps.options}
            onChange={(newValue) => props.onChange(newValue?.value)}
            value={viewProps.value?.value}
            isDisabled={props.disabled}
            onMenuScrollToBottom={viewProps.onScrollToBottom}
            loadOptions={viewProps.search}
            isClearable={props.isClearable}
            useConditionedStyling={props.useConditionedStyling}
        />
    );
};
